import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { intl } from 'lang/intl'

import { TtIcon as Icon } from '@23/react'

import { AvatarComponent as Avatar } from '..'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 2px;
  margin-bottom: 2px;
  min-width: 0;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  padding: 0px;
  padding-top: 2px;
  padding-bottom: 2px;
`

const Nameplates = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding-left: 10px;
`

const textOverflow = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const NameContainer = styled.div`
  line-height: 15px;
  display: flex;
`

const Role = styled.div`
  border: 1px solid #979797;
  border-radius: 2px;
  color: #676767;
  font-size: 10px;
  text-transform: uppercase;
  padding-left: 3px;
  padding-right: 3px;
  margin-left: 8px;
`

const Name = styled.p`
  ${textOverflow}
  color: #043623;
  display: block;
  font-size: 12px;
  line-height: 15px;
  margin: 0px;
  padding: 0px;
  padding-bottom: 2px;
`

const Title = styled.p`
  ${textOverflow}
  color: #676767;
  display: block;
  font-size: 12px;
  line-height: 15px;
  margin: 0px;
  padding: 0px;
  padding-top: 1px;
`

const SocialIcons = styled.span`
  display: inline-flex;
  flex-wrap: wrap;
  margin-left: 10px;
  gap: 6px;
  vertical-align: -1px;
  a {
    display: block;
    .icon {
      color: #676767;
    }
  }
`

const SpeakerRowComponent = ({
  name,
  title,
  link,
  linkedin,
  facebook,
  twitter,
  company,
  avatarUrl,
  isHost = false,
  disabled = false,
}) => (
  <Container disabled={disabled}>
    <Avatar imageSrc={avatarUrl} name={name} size={35} shape="square" />
    <Nameplates>
      <NameContainer>
        <Name>{name}</Name>
        {isHost && (
          <Role>
            <FormattedMessage defaultMessage="Host" />
          </Role>
        )}
      </NameContainer>
      {title && (
        <Title>
          {title}
          {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
          {company && ` • ${company}`}
          <SocialIcons>
            {link && (
              <a href={link} target="_new">
                <Icon
                  name="globe"
                  library="one"
                  className="icon"
                  aria-label={intl.formatMessage({
                    defaultMessage: 'website link',
                  })}
                />
              </a>
            )}
            {linkedin && (
              <a href={linkedin} target="_new">
                <Icon
                  name="linkedin"
                  library="one/logos"
                  className="icon"
                  aria-label={intl.formatMessage({
                    defaultMessage: 'linkedin link',
                  })}
                />
              </a>
            )}
            {facebook && (
              <a href={facebook} target="_new">
                <Icon
                  name="facebook"
                  library="one/logos"
                  className="icon"
                  aria-label={intl.formatMessage({
                    defaultMessage: 'facebook link',
                  })}
                />
              </a>
            )}
            {twitter && (
              <a href={twitter} target="_new">
                <Icon
                  name="twitter"
                  library="one/logos"
                  className="icon"
                  aria-label={intl.formatMessage({
                    defaultMessage: 'twitter link',
                  })}
                />
              </a>
            )}
          </SocialIcons>
        </Title>
      )}
    </Nameplates>
  </Container>
)

SpeakerRowComponent.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  company: PropTypes.string,
  avatarUrl: PropTypes.string,
  facebook: PropTypes.string,
  twitter: PropTypes.string,
  linkedin: PropTypes.string,
  link: PropTypes.string,
  isHost: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default SpeakerRowComponent
